import classNames from "classnames";

export default function OrLineSeparator({ className }) {
  return (
    <div
      className={classNames(
        "w-relative flex my-8 items-center w-full",
        className
      )}
    >
      <div className="flex-grow border-t border-gray-3"></div>
      <span className="flex-shrink mx-4 text-sm font-semibold">OR</span>
      <div className="flex-grow border-t border-gray-3"></div>
    </div>
  );
}
